<template>
  <section>
      <img :src="baseURL+'img/logo.png'" alt="Sofca">
      <h1>Votre service relevé kilométrique évolue</h1>
      <small class="info">
        Rendez-vous désormais sur votre application Mon Allianz mobile ou adressez-vous à votre interlocuteur Allianz habituel pour effectuer votre relevé kilométrique.
      </small>
  </section>
</template>

<script>
  export default {
    data() {
      return {
        baseURL: process.env.BASE_URL,
      }
    }
  }
</script>

<style scoped lang="scss">
  @import '@/assets/_vars.scss';

  section {
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 100vh;
    background-size: cover;

    // Center vertically
    &:before {
      content: '';
      flex: .5;
    }
  }

  h1 {
    font-weight: 500;
    text-align: center;
    font-size: 1.5em;
    line-height: 1.2;
    color: color('secondaryBlue');
    margin-top: spacer(2);
    margin-bottom: spacer(2);
  }

  .info {
    display: block;
    font-size: 1em;
    color: #003781;
    margin-top: spacer(2);
    padding-left: 1.5em;
    position: relative;

    img {
      width: 1.1em;
      height: 1.1em;
      position: absolute;
      left: 0;
    }
  }

  .help {
    &.auth {
      text-align: center;
      width: 100%;
      display: block;
      margin-top: 80px;

      a {
        color: #fff;
        font-size: 1.3em;
        text-decoration: none;
        font-weight: lighter;
      }
    }
  }
</style>
